import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { changeExpandedIndex, setIsUpOrDownKeyClicked } from 'store';

const useKeyboardNavigation = (totalCount, handleScrollClick) => {
  const dispatch = useDispatch();
  const isExpanded = useSelector((state) => state.contentReducer.isExpanded);
  const expandedIndex = useSelector(
    (state) => state.contentReducer.expandedIndex
  );
  useEffect(() => {
    const handleKeyUp = (event) => {
      if (event.key === 'ArrowUp' && expandedIndex > 0 && isExpanded) {
        const newIndex = expandedIndex - 1;
        dispatch(
          changeExpandedIndex({
            index: newIndex,
          })
        );

        handleScrollClick(newIndex);
      } else if (
        event.key === 'ArrowDown' &&
        expandedIndex < (totalCount ?? 0) - 1 &&
        isExpanded
      ) {
        const newIndex = expandedIndex + 1;
        dispatch(
          changeExpandedIndex({
            index: newIndex,
          })
        );

        handleScrollClick(newIndex);
      }
    };

    const handleKeyDown = (event) => {
      if (
        isExpanded &&
        (event.key === 'ArrowDown' || event.key === 'ArrowUp')
      ) {
        event.preventDefault();
        dispatch(setIsUpOrDownKeyClicked(true));
      }
    };

    window.addEventListener('keyup', handleKeyUp);
    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [expandedIndex, totalCount]);
};

export default useKeyboardNavigation;
